import React from "react";
import {AutoComplete, Select, Typography} from "antd"
import {getPluginField, removeFieldType} from "../../../editors/WebEditor/formPlugins";

const {Text} = Typography

export default class SelectDataField extends React.Component {
    render() {
        const {edit, propertie, value, onChange, form} = this.props

        if (!edit) {
            var finalValue = value
            if (!Array.isArray(finalValue)) {
                finalValue = [finalValue]
            }
            return <Text>{finalValue.join(",")}</Text>
        }


        const plugin = getPluginField(JSON.parse(form?.content), removeFieldType(propertie))
        const options = plugin?.dataI18n?.default?.values || []

        if (propertie.startsWith("[SELECT]_")) {
            return (
                <AutoComplete
                    options={options.map(i => ({label: i, value: i}))}
                    style={{width: "100%"}}
                    defaultValue={value}
                    onChange={(v) => onChange(v)}
                />
            )
        }

        if (propertie.startsWith("[SELECT_MULTI]_")) {
            return (
                <Select style={{width: "100%"}} mode="tags" defaultValue={value} onChange={(v) => onChange(v)}>
                    {options.map(i => <Select.Option value={i}>{i}</Select.Option>)}
                </Select>
            )
        }


    }
}
